module.exports = __webpack_public_path__ + "img/room_wait2.330bd1a5.png";